import React, { useState, useEffect } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { useCookies } from 'react-cookie'
import axios from 'axios'
import './Login.css' // Import your CSS file

function ForgotPassword() {
  const navigate = useNavigate()
  const [email, setEmail] = useState('')
  const [message, setMessage] = useState('')
  const [error, setError] = useState('')
  const handleSubmit = async (e) => {
    e.preventDefault()
    setMessage('')
    setError('')

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}forgot-password`,
        { email }
      )

      setMessage(
        response.data.message || 'Password reset email sent successfully!'
      )
    } catch (err) {
      setError(err.response?.data?.message || 'An error occurred.')
    }
  }

  return (
    <div class="login-container">
      <div class="image-div">
        <img src="/images/login_Illustration.svg" />
      </div>
      <div class="form-div">
        <div class="form-container">
          <img src="/logo.png" alt="Brilliant Prep Logo" class="logo" />
          <div class="form-header">Forgot Password</div>
          <Link to="/" class="signup-link">
            <span>Already have an account</span> Sign In →
          </Link>
          <form autoComplete="off" onSubmit={(e) => handleSubmit(e)}>
            <div class="inputBox">
              <input
                placeholder="Email Address"
                value={email}
                id="uname"
                type="email"
                name="email"
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
            <div class="login-btn">
              <input type="submit" value="Submit" />
            </div>
          </form>
          {message && <p style={{ color: 'green' }}>{message}</p>}
          {error && <p style={{ color: 'red' }}>{error}</p>}
        </div>
      </div>
    </div>
  )
}

export default ForgotPassword
